/**
 * @public
 */
export interface PaginationEventInit extends EventInit {
  page: number
  pageSize: number
  extra?: Record<string, unknown>
}

/**
 * @public
 */
export class PaginationEvent extends Event {
  page: number
  pageSize: number
  extra?: Record<string, unknown>

  constructor(type: string, eventInitDict: PaginationEventInit) {
    super(type, eventInitDict)
    this.page = eventInitDict.page
    this.pageSize = eventInitDict.pageSize
    this.extra = eventInitDict?.extra ?? null
  }
}
